import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { XCircle } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";

export function DeclineSummary({ companyId, isAdmin }) {
  const [d, setD] = useState(null);
  useEffect(() => { if (companyId) api.get("/offer-decline-summary", { params: isAdmin ? { company_id: companyId } : {} }).then((r) => setD(r.data)).catch(() => {}); }, [companyId, isAdmin]);
  if (!d || d.total === 0) return null;
  const max = Math.max(...d.reasons.map((r) => r.count));
  return (
    <Card className="p-4 space-y-3" data-testid="decline-summary">
      <div className="font-display font-semibold flex items-center gap-1.5 text-sm"><XCircle className="w-4 h-4 text-rose-500" /> Decline reasons <span className="text-xs text-muted-foreground font-normal">({d.total} declined)</span></div>
      <div className="grid sm:grid-cols-2 gap-4">
        <ul className="space-y-1.5">
          {d.reasons.map((r) => (
            <li key={r.reason} data-testid={`decline-reason-row-${r.reason.split(" ")[0].toLowerCase()}`} className="text-xs">
              <div className="flex justify-between"><span>{r.reason}</span><span className="font-mono-num text-muted-foreground">{r.count}</span></div>
              <div className="h-1.5 rounded-full bg-muted overflow-hidden"><div className="h-full bg-rose-500 rounded-full" style={{ width: `${(r.count / max) * 100}%` }} /></div>
            </li>
          ))}
        </ul>
        <ul className="space-y-1 text-xs">
          {d.recent.slice(0, 5).map((r) => <li key={r.id} className="flex justify-between gap-2 border-b border-dashed border-border/60 py-1"><span className="truncate">{r.candidate} · {r.job_title}</span><span className="text-muted-foreground whitespace-nowrap">{r.reason}{r.at && ` · ${fmtDate(r.at.slice(0, 10))}`}</span></li>)}
        </ul>
      </div>
    </Card>
  );
}
